import { render, staticRenderFns } from "./XhFiles.vue?vue&type=template&id=1033d912&scoped=true"
import script from "./XhFiles.vue?vue&type=script&lang=js"
export * from "./XhFiles.vue?vue&type=script&lang=js"
import style0 from "./XhFiles.vue?vue&type=style&index=0&id=1033d912&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1033d912",
  null
  
)

export default component.exports